
const state = {
  loadingAnalysis: false,
  loadingAnalysisSelldata: false,
}
const getters = {
  getLoadingAnalysis: state => state.loadingAnalysis,
  getLoadingAnalysisSelldata: state => state.loadingAnalysisSelldata,
}
const mutations = {
  setLoadingAnalysis(state, value) { state.loadingAnalysis = value },
  setLoadingAnalysisSelldata(state, value) { state.loadingAnalysisSelldata = value },
}
const actions = {
  updateLoadingAnalysis({commit}, data) { commit('setLoadingAnalysis', data) },
  updateLoadingAnalysisSelldata({commit}, data) { commit('setLoadingAnalysisSelldata', data) },
}

export {
  state,
  getters,
  mutations,
  actions
}
